/* global axios */
import ApiClient from './ApiClient';

export const buildContactParams = (page, sortAttr, label, search,state_id,status_id,filters) => {
  let params = `include_contact_inboxes=false&page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (label) {
    params = `${params}&labels[]=${label}`;
  }
  if (state_id){
    params = `${params}&state_id=${state_id}`;
  }
  if (status_id){
    params = `${params}&status_id=${status_id}`;
  }
  if (filters && filters.length > 0) {
    console.log("filters",filters);
    filters.forEach((filter, i) => {
      Object.keys(filter).forEach(key => {
        const value = filter[key];
        if (value !== undefined && value !== null && value !== '') {
          params += `&filters[${i}][${key}]=${encodeURIComponent(value)}`;
        }
      });
    });
  }
  return params;
};

class ContactAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(page, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}?${buildContactParams(
      page,
      sortAttr,
      label,
      ''
    )}`;
    return axios.get(requestURL);
  }

  getContact(contactId) {
    return axios.get(`${this.url}/${contactId}`);
  }

  getConversations(contactId) {
    return axios.get(`${this.url}/${contactId}/conversations`);
  }

  getContactableInboxes(contactId) {
    return axios.get(`${this.url}/${contactId}/contactable_inboxes`);
  }

  getContactLabels(contactId) {
    return axios.get(`${this.url}/${contactId}/labels`);
  }

  updateContactLabels(contactId, labels) {
    return axios.post(`${this.url}/${contactId}/labels`, { labels });
  }

  search(search = '', page = 1, sortAttr = 'name', label = '',state_id,status_id,filters) {
    let requestURL = `${this.url}/search?${buildContactParams(
      page,
      sortAttr,
      label,
      search,
      state_id,
      status_id,
      filters
    )}`;
    return axios.get(requestURL);
  }

  // filter(page = 1, sortAttr = 'name', queryPayload) {
  //   let requestURL = `${this.url}/filter?${buildContactParams(page, sortAttr)}`;
  //   return axios.post(requestURL, queryPayload);
  // }

  filter(page = 1, sortAttr = 'name', payload, search = '') {
    const requestURL = `${this.url}/filter?${buildContactParams(
      page,
      sortAttr,
      '',
      search
    )}`;
    return axios.post(requestURL, payload);
  }


  importContacts(file, inboxId, agentList, macroId, label_list, boardId, statusId) {
    const formData = new FormData();
    formData.append('import_file', file);
    formData.append('inbox_id', inboxId);
    formData.append('agent_list', agentList);
    if (macroId != null) {
      formData.append('macro_id', macroId);
    }  
    formData.append('label_list',label_list)
    if (boardId != null) {
      formData.append('board_id', boardId);
    }

    if (statusId != null) {
      formData.append('status_id', statusId); 
    }
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  destroyCustomAttributes(contactId, customAttributes) {
    return axios.post(`${this.url}/${contactId}/destroy_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  destroyAvatar(contactId) {
    return axios.delete(`${this.url}/${contactId}/avatar`);
  }

  exportContacts(q, filters) {
    return axios.post(`${this.url}/export`,{q, filters});
  }

  getAttachments(contactId) {
    return axios.get(`${this.url}/${contactId}/contact_attachments`);
  }

  update_demo(conversationId, data) {
    const url = this.url;
    const parts = url.split('/');
    parts.pop(); // Remove the last part
    const newUrl = parts.join('/');
    return axios.patch(`${newUrl}/conversations/${conversationId}/demo_time`, {
      scheduleType: data.scheduleType,
      reminderNote: data.reminderNote,
      calendar_timings: data.calendar_timings,
      meet_link: data.meetingLink || null,
      message: data.messages
    });
  }

   update_contact_demo(contactId, data) {
    const url = this.url;
    const parts = url.split('/');
    parts.pop(); // Remove the last part
    const newUrl = parts.join('/');
    return axios.patch(`${newUrl}/contacts/${contactId}/demo_time`, {
      reminderNote: data.reminderNote,
      calendar_timings: data.calendar_timings,
      meet_link: data.meetingLink || null,
      message: data.messages,
      demo_timing: data.demo_timing || null,
      meeting_link: data.meeting_link || null
    });
  }

  update_contact_demo_meeting(contactId, data) {
    const url = this.url;
    const parts = url.split('/');
    parts.pop();
    const newUrl = parts.join('/');
    const payload = {
      scheduleType: 'demo_meeting',
      demo_timing: data.demo_timing,
      meeting_link: data.meeting_link,
      demo_subject: data.demo_subject,
    };
    if (data.event_id) {
      payload.event_id = data.event_id;
    }
    if (Object.prototype.hasOwnProperty.call(data, 'meeting_description')) {
      payload.meeting_description = data.meeting_description;
    }
    if (data.manual_external_booking) {
      payload.manual_external_booking = true;
    }
    return axios.patch(`${newUrl}/contacts/${contactId}/demo_time`, payload);
  }

  update_contact_demo_read(contactId,data) {
    const url = this.url;
    const parts = url.split('/');
    parts.pop(); // Remove the last part
    const newUrl = parts.join('/');
    return axios.patch(`${newUrl}/contacts/${contactId}/mark_demo_readed`, {
      isReaded: data.isReaded,
    });
  }

  update_demo_contact(contactId,data){
    return axios.patch(`${this.url}/${contactId}/`,{
      meet_link: data.meetingLink || '',
      scheduleType: data.scheduleType,
    })
  }

  schedule_demo( data) {
    return axios.post(`https://calendar.kivo.ai/backend/booking/appointment`, {
      ...data
    });
  }
  getSlot(eventId)
  {
    return axios.get(`https://calendar.kivo.ai/backend/events/getEventsByUniqueId/${eventId}`)
  }
  getstate(id,contact_id){
    console.log("Hi:::::::",id,contact_id);
    const updatedUrl = this.url.replace('/contacts', '');
    return axios.get(`${updatedUrl}/states/${id}?contact_id=${contact_id}`);
  }
  assignstatus(contactId,statusId){
    const updatedUrl = this.url.replace('/pipelines', '' );
    return axios.put(`${updatedUrl}/contacts/${contactId}`,{
      status_id: statusId
    });
  }
  assignstate(contactId,stateId,description){
    // const updatedUrl = this.url.replace('/pipelines', '' );
    return axios.put(`${this.url}/${contactId}`,{
      state_id:stateId,
      state_description:description
    });
  }
  getboard(id){
    const updatedUrl = this.url.replace('/contacts', '');
    console.log("Hello",this.url,updatedUrl,id);
    return axios.get(`${updatedUrl}/board/${id}`);
  }
  assignboard(contactId,boardId,description){
    // const updatedUrl = this.url.replace('/pipelines', '' );
    return axios.put(`${this.url}/${contactId}`,{
      board_id:boardId,
      description:description
    });
  }
  sendreport(data){
    return axios.post(`${this.url}/send_report`,data);
  }
}

export default new ContactAPI();